// JsFromRoutes CacheKey 4a554151f6f19b78d31d2a0e5007d097
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@/utils/definePathHelper'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '(/:locale)/builds'),
  comp: /* #__PURE__ */ definePathHelper('post', '(/:locale)/comps/:comp_id/builds'),
  new: /* #__PURE__ */ definePathHelper('get', '(/:locale)/builds/new'),
  newCompBuild: /* #__PURE__ */ definePathHelper('get', '(/:locale)/comps/:comp_id/builds/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '(/:locale)/builds/:id/edit'),
  editCompBuild: /* #__PURE__ */ definePathHelper('get', '(/:locale)/comps/:comp_id/builds/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '(/:locale)/builds/:id'),
  compBuild: /* #__PURE__ */ definePathHelper('get', '(/:locale)/comps/:comp_id/builds/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '(/:locale)/builds/:id'),
  updatePatch: /* #__PURE__ */ definePathHelper('patch', '(/:locale)/comps/:comp_id/builds/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '(/:locale)/builds/:id'),
  destroyDelete: /* #__PURE__ */ definePathHelper('delete', '(/:locale)/comps/:comp_id/builds/:id'),
}
